import {createStore} from 'vuex'
import axios from "axios"

export default createStore({
    state: {
        activeLeftNav: 'blueprint',
        House: '',
        floorplans: [],
        pakets: [],
        services: [],
        currentFloorplan: {},
        currentPaket: {},
        choosedServices: [],
        order: {
            purchase_country: 'SE',
            purchase_currency: 'SEK',
            locale: 'sv-se',
            order_amount: 0,
            order_tax_amount: 0,
            order_lines: [],
            merchant_urls: {
                terms: "https://husverket.se/personuppgiftspolicy-cookies/",
                checkout: process.env.VUE_APP_PUBLIC_HOME + "/varukorg",
                confirmation: process.env.VUE_APP_PUBLIC_HOME + "/floorplan-order-confirmation?klarna_order_id={checkout.order.id}",
                push: "https://www.example.com/api/push"
            }
        },
        CreatedOrder: {},
        html_snippet: '',
        Basket: {
            floorplan: {},
            paket: {},
        }
    },
    getters: {},
    mutations: {
        splice_service(state, payload) {
            console.log(payload)
            state.choosedServices.splice(payload.index, 1)
            let orderLineIndex = state.order.order_lines.findIndex(x => x.reference === payload.service.id)
            state.order.order_lines.splice(orderLineIndex, 1)
            let totalPrice = state.order.order_lines.reduce((a, b) => {
                return a + parseFloat(b.total_amount)
            }, 0)
            console.log(totalPrice)
            state.order.order_amount = totalPrice
            state.order.order_tax_amount = Math.round(totalPrice * 0.2)
        },
        add_new_service(state, payload) {
            console.log(payload)
            state.choosedServices.push(payload)
            let unit_price = payload.price * 100
            let tax_rate = 2500
            let orderLine = {
                name: payload.title,
                type: "physical",
                reference: payload.id,
                quantity: 1,
                quantity_unit: "pcs",
                unit_price: unit_price,
                tax_rate: tax_rate,
                total_amount: unit_price,
                total_discount_amount: 0,
                total_tax_amount: Math.round(unit_price * 0.2)
            }
            state.order.order_lines.push(orderLine)
            state.order.order_amount = state.order.order_amount + unit_price
            state.order.order_tax_amount = Math.round(state.order.order_amount * 0.2)
        },
        commit_floorplans_setup(state, payload) {
            console.log(payload)
            state.floorplans = payload.FloorPlans
            state.currentFloorplan = state.floorplans[0]
            state.pakets = payload.Pakets
            // state.services = payload.Services
            state.House = payload.House
        },
        mutate_activeLeftNav(state, payload) {
            state.activeLeftNav = payload
        },
        mutate_currentFloorplan(state, payload) {
            state.currentFloorplan = payload
            //  state.Basket.floorplan = payload
        },

        mutate_currentPaket(state, payload) {
            let paket = payload.paket
            let indx = payload.index
            state.currentPaket = paket
            //  state.Basket.paket = paket
            Array.from(document.getElementsByClassName('MyBuilder__body__body__holder__card')).forEach(x => {
                x.classList.remove('active')
            })
            document.getElementById(paket.id).classList.add('active')
            state.choosedServices = []
            let unit_price = paket.price * 100
            let tax_rate = 2500
            let order_lines =
                {
                    name: state.currentFloorplan.title + ' - ' + state.currentPaket.title + ' paket' + ' - ' + state.currentFloorplan.type,
                    type: "physical",
                    reference: paket.id,
                    quantity: 1,
                    quantity_unit: "pcs",
                    unit_price: unit_price,
                    tax_rate: tax_rate,
                    total_amount: unit_price,
                    total_discount_amount: 0,
                    total_tax_amount: Math.round(unit_price * 0.2)
                }
            if (state.order.order_lines.length > 0) {
              state.order.order_lines = state.order.order_lines.filter(
                  line => line.reference === 'BYGGLOV_HELP'
              );

            }
           state.order.order_lines.unshift(order_lines);

            state.order.order_amount = unit_price
            state.order.order_tax_amount = Math.round(unit_price * 0.2)
        },
      commit_service_help(state, payload) {
        const reference = 'BYGGLOV_HELP';

        const bygglovHelpLine = {
          name: 'Hjälp med bygglov',
          type: 'physical',
          reference,
          quantity: 1,
          quantity_unit: 'pcs',
          unit_price: 0,
          tax_rate: 0,
          total_amount: 0,
          total_discount_amount: 0,
          total_tax_amount: 0
        };

        const index = state.order.order_lines.findIndex(line => line.reference === reference);

        if (payload) {
          // Add if not already present
          if (index === -1) {
            state.order.order_lines.push(bygglovHelpLine);
          }
        } else {
          // Remove if present
          if (index !== -1) {
            state.order.order_lines.splice(index, 1);
          }
        }
      },
      mutate_klarnaorder(state, payload) {
            state.CreatedOrder = payload
            state.html_snippet = payload.html_snippet
        },
    },
    actions: {
        retriveFloorPlans({commit}) {
            let HousePostId = window.house_postId
            HousePostId === undefined ? HousePostId = 44273 : HousePostId
            axios.get(process.env.VUE_APP_PUBLIC_API_URL + '/retrive_house_floorplans', {
                params: {
                    house: HousePostId
                }
            }).then(res => {
                commit('commit_floorplans_setup', res.data)
            })
        },
        klarnaInner({commit}, e) {
            var checkoutContainer = document.getElementById('my-checkout-container')
            checkoutContainer.innerHTML = e.html_snippet.replace(/\\"/g, "\"").replace(/\\n/g, "");
            var scriptsTags = checkoutContainer.getElementsByTagName('script')
            for (var i = 0; i < scriptsTags.length; i++) {
                var parentNode = scriptsTags[i].parentNode
                var newScriptTag = document.createElement('script')
                newScriptTag.type = 'text/javascript'
                newScriptTag.text = scriptsTags[i].text
                parentNode.removeChild(scriptsTags[i])
                parentNode.appendChild(newScriptTag)
            }
            commit('mutate_klarnaorder', e)
        },
        create_order({commit, rootState, dispatch}) {
            let order_id = Object.keys(rootState.CreatedOrder).length > 0 ? rootState.CreatedOrder.order_id : ''
            axios.post(process.env.VUE_APP_PUBLIC_API_URL + '/create_floorplan_order', {
                order: JSON.stringify(rootState.order),
                env: false,
                order_id: order_id
            }).then(res => {
                dispatch('klarnaInner', res.data)
            })
        },
        commit_activeLeftNav({commit}, payload) {
            commit('mutate_activeLeftNav', payload)
        },
        commit_floorplan({commit}, payload) {
            commit('mutate_currentFloorplan', payload)
        },
        commit_paket({commit}, payload) {
            commit('mutate_currentPaket', payload)
        },
    },
    modules: {}
})
